import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { Box, Checkbox, CircularProgress } from "@mui/material";
import { useRouter } from "next/router";
import { ChangeEvent, useState } from "react";
import { useSelector } from "react-redux";

import UserType from "../constants/UserType";
import { addFavouriteChef, removeFavouriteChef } from "../firebase/user";
import { theme } from "../mui-customs/Theme";
import { RootState } from "../redux/store";

interface LikeAndUnLikeProps {
  chefUid: string;
}
const LikeAndUnLikeChef = ({ chefUid }: LikeAndUnLikeProps) => {
  const userType = useSelector((state: RootState) => state.user.user.userType);
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  const likedChefs = useSelector(
    (state: RootState) => state.user.user.likedChefs
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const router = useRouter();
  const handleLikeAndUnlike = async (event: ChangeEvent<HTMLInputElement>) => {
    if (!userUid) {
      router.push("/auth/login");
      return;
    }
    setIsProcessing(true);
    if (event.target.checked) {
      await addFavouriteChef(userUid, chefUid);
    } else {
      await removeFavouriteChef(userUid, chefUid);
    }
    setIsProcessing(false);
  };
  if (userType === UserType.Chef) {
    return <></>;
  }
  return isProcessing ? (
    <Box sx={{ p: "9px", display: "grid", placeItems: "center" }}>
      <CircularProgress
        sx={{ color: theme.grey1[400] }}
        size={24}
        thickness={4}
      />
    </Box>
  ) : (
    <Checkbox
      defaultChecked={likedChefs?.includes(chefUid)}
      sx={{
        backgroundColor: `${theme.whiteBg.WBG4} !important`,
        height: "fit-content",
      }}
      onChange={handleLikeAndUnlike}
      icon={<FavoriteBorder sx={{ color: theme.grey2[500] }} />}
      checkedIcon={<Favorite sx={{ color: theme.brand2[500] }} />}
    />
  );
};

export default LikeAndUnLikeChef;
